export default __webpack_public_path__ + "static/media/burgerset.2fec5207.svg";